import React, { useState, useEffect } from 'react';
import '../styles/layout/LandingPage.scss';
import { Box, Stack, Typography,Container,Paper, Button, Modal } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { grey } from '@mui/material/colors';
import { Link } from 'react-router-dom';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  boxShadow: 3,
  borderRadius: "20px",
  p: 3,
};

const ClientPage = () => {

  const [open, setOpen] = useState(false)

    useEffect(() =>{
    },[])

    const handleModel = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
        return (<>
          <Container sx={{ backgroundColor:"#FFEEF9", height:"786px", maxWidth:"100% !important"}}>
          <Typography 
            sx={{
              fontFamily: "Orbitron",
              fontSize: { xs: '30px', sm: '40px', md: '50px' }, // Responsive font size
              fontWeight: 'bold',
              textAlign: 'center',
              paddingTop: { xs: '30%', sm: '5%' }, // Adjust padding for mobile
              paddingBottom: { xs: '5%', sm: '3%' }, // Adjust padding for mobile
            }}
          >
            Our Technology Partners
          </Typography>

            <Stack direction="row" spacing={0} sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" } }} 
            className="ourTechPartner">
              <Box
                sx={{
                  flex: { xs: 1, sm: 1.2 },
                  height: { xs: "250px", sm: "490px" }, // Shrink height for mobile
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "center", sm: "end" },
                  justifyContent: "center",
                  width: "100%",
                  padding: { xs: "8px", sm: "20px" }, // Shrink padding for mobile
                  marginTop: { xs: "20px", sm: "20px" },  // Shrink Paper width for mobile

                }}
              >
                <Paper
                  sx={{
                    position: "relative",
                    borderRadius: "220px",
                    backgroundColor: "#4D0033",
                    height: { xs: "100px", sm: "200px" }, // Shrink Paper height for mobile
                    width: { xs: "250px", sm: "450px" },
                 // Shrink Paper width for mobile
                    overflow: "hidden",
                  }}
                >
                  <img
                    alt=""
                    src="/assets/landingPage/OurTecPartner_RotatingWheel.png"
                    className="spinningImage"
                    style={{ maxWidth: "100%" }} // Ensure image is responsive
                  />
                  <img
                    alt=""
                    src="/assets/landingPage/OurTecPartner_RotatingWheelLogo.png"
                    className="fixedImage"
                    style={{ maxWidth: "80%" }} // Shrink image size for mobile
                  />
                </Paper>
              </Box>

              <Box sx={{ flex: 1, height: { xs: "400px", sm: "550px" }, marginRight: { xs: "0", sm: "18%" }, zIndex: 1000 }}>
                <Typography
                  sx={{
                    fontFamily: "Orbitron",
                    fontSize: { xs: "22px", sm: "27px" }, // Shrink font size for mobile
                    fontWeight: "bold",
                    textAlign: { xs: "center", sm: "right" }, // Center for small screens, right for larger screens
                    paddingTop: "5%",
                    marginTop: "10%", 
                  }}
                >
                  Speed up Success in data + AI
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: { xs: "16px", sm: "22px" }, // Shrink font size for mobile
                    fontWeight: "normal",
                    textAlign: { xs: "center", sm: "right" }, // Center for small screens, right for larger screens
                    paddingTop: "0%",
                    marginTop: "8%",
                  }}
                >
                  Our tools integrate with your current tools
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: { xs: "16px", sm: "22px" }, // Shrink font size for mobile
                    fontWeight: "normal",
                    textAlign: { xs: "center", sm: "right" }, // Center for small screens, right for larger screens
                    paddingTop: "0%",
                  }}
                >
                  for ETL, data ingestion, business intelligence
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: { xs: "16px", sm: "22px" }, // Shrink font size for mobile
                    fontWeight: "normal",
                    textAlign: { xs: "center", sm: "right" }, // Center for small screens, right for larger screens
                    paddingTop: "0%",
                  }}
                >
                  AI and governance. Adopt what’s next
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: { xs: "16px", sm: "22px" }, // Shrink font size for mobile
                    fontWeight: "normal",
                    textAlign: { xs: "center", sm: "right" }, // Center for small screens, right for larger screens
                    paddingTop: "0%",
                  }}
                >
                  without throwing away what works.
                </Typography>

                <Button
                  sx={{
                    border: "2px solid #fff",
                    color: "#fff",
                    backgroundColor: "#F005A2",
                    borderRadius: "55px",
                    width: { xs: "180px", sm: "220px" }, // Shrink button width for mobile
                    height: { xs: "45px", sm: "57px" }, // Shrink button height for mobile
                    fontFamily: "Inter",
                    fontWeight: "bold",
                    fontSize: { xs: "16px", sm: "20px" }, // Shrink font size for mobile
                    marginTop: {sm:"20%", xs:"10%"},
                    marginLeft: { xs: "25%", sm: "61%" },
                    textTransform: "capitalize",
                  }}
                  onClick={handleModel}
                >
                  Take a Glance
                </Button>
                <img alt="polygonimg" src="/assets/landingPage/OurTechPartner_Polygon.png" className="angleImg" />
              </Box>
            </Stack>



        <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ borderBottom: "1px solid #8E8E8E", fontWeight: "bold", p:"0 0 5px 0", color:"#464646", textAlign:"center"}}>
          TOOLS & INTEGRATIONS
          <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 18,
            top: 18,
            color: "#000",
            padding:"5px",
            backgroundColor:"#F0F0F0 !important"
          })}
        >
          <CloseIcon />
        </IconButton>
          </Typography>
          <Box id="modal-modal-description" sx={{ mt: 2, display:"flex", alignItems:"center", justifyContent:"center" }}>
          <img alt="" src="/assets/landingPage/modelImg.webp" loading='lazy' className='modelIMg' ></img>
          </Box>
        </Box>
      </Modal>
         

      </Container>
      <Container
  sx={{
    height: "auto",
    backgroundColor: "#000000",
    maxWidth: "100% !important",
    position: "relative",
    backgroundImage: `url('/assets/landingPage/countPatterns.png')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    padding: { xs: "5% 3%", sm: "3% 5%" }, // Adjust padding for mobile
  }}
>
  {/* Section Heading */}
  <Typography
    sx={{
      fontFamily: "Orbitron",
      fontSize: { xs: "28px", sm: "40px" }, // Responsive font size
      fontWeight: "bold",
      color: "#FFFFFF",
      letterSpacing: "2px",
      textAlign: "center",
      paddingBottom: { xs: "3%", sm: "2%" },
    }}
  >
    Some count that matters
  </Typography>

  {/* Description */}
  <Typography
    sx={{
      fontFamily: "Poppins",
      fontSize: { xs: "18px", sm: "25px" }, // Reduce font size for mobile
      color: "#FFFFFF",
      lineHeight: { xs: "30px", sm: "47.6px" }, // Adjust line height
      letterSpacing: "1px",
      textAlign: "center",
      paddingBottom: { xs: "5%", sm: "3%" },
    }}
  >
    Our achievement in the journey depicted in numbers
  </Typography>

  {/* Stats Section */}
  <Stack
    direction={{ xs: "column", sm: "row" }} // Column on mobile, row on desktop
    spacing={2}
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      paddingBottom: { xs: "5%", sm: "3%" },
    }}
  >
    {[
      { value: "10", label: "Clients" },
      { value: "200+", label: "Taken business legalities" },
      { value: "6", label: "Years of Journey" },
    ].map((item, index) => (
      <Box
        key={index}
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "auto",
          width: { xs: "100%", sm: "340px" }, // Full width on mobile, fixed on desktop
          alignItems: "center",
          borderRight: {
            xs: "none",
            sm: index !== 2 ? "1px solid rgba(255, 255, 255, 0.4)" : "none",
          }, // Remove border on last item in desktop view
          padding: { xs: "3%", sm: "0" }, // Add spacing on mobile
        }}
      >
        <Typography
          sx={{
            fontFamily: "Poppins",
            fontWeight: 800,
            color: "#FFFFFF",
            fontSize: { xs: "48px", sm: "64px" }, // Smaller font for mobile
          }}
        >
          {item.value}
        </Typography>
        <Typography
          sx={{
            fontFamily: "Poppins",
            fontWeight: "normal",
            color: "#FFFFFF",
            fontSize: { xs: "12px", sm: "14px" }, // Smaller font for mobile
          }}
        >
          {item.label}
        </Typography>
      </Box>
    ))}
  </Stack>
</Container>

      
      <Container sx={{ height:"auto", backgroundColor:"#fff",maxWidth:"100% !important", position:"relative", overflow:"hidden"}}>
        <div className="section-heading" style={{display:"flex", alignContent:"center", justifyContent:"center", height:"55px", paddingTop:"5%"}}>
          <div className='clientele-title' style={{fontFamily:"Orbitron", fontSize: '45px', fontWeight:'bold', color:"#000", letterSpacing:"2px"}}>Our Clientele</div>
        </div>
        <Stack className="clientImagCont" direction="row" spacing={0} sx={{ display:"flex", justifyContent:"space-evenly", padding: "5% 0 3% 0",   animation: "clientImagCont 20s linear infinite", width:"100%"}}>
        
         <img alt="" src="/assets/landingPage/OurClientele/intel.png" className='clientele' ></img>
         <img alt="" src="/assets/landingPage/OurClientele/McA.png" className='clientele' ></img>
         <img alt="" src="/assets/landingPage/OurClientele/IBM.png" className='clientele' ></img>          
         <img alt="" src="/assets/landingPage/OurClientele/TATA.png" className='clientele' ></img>
         <img alt="" src="/assets/landingPage/OurClientele/IQVIA.png" className='clientele' ></img>  

         <img alt="" src="/assets/landingPage/OurClientele/intel.png" className='clientele' ></img>
         <img alt="" src="/assets/landingPage/OurClientele/McA.png" className='clientele' ></img>
         <img alt="" src="/assets/landingPage/OurClientele/IBM.png" className='clientele' ></img>          
         <img alt="" src="/assets/landingPage/OurClientele/TATA.png" className='clientele' ></img>
         <img alt="" src="/assets/landingPage/OurClientele/IQVIA.png" className='clientele' ></img> 

         <img alt="" src="/assets/landingPage/OurClientele/intel.png" className='clientele' ></img>
         <img alt="" src="/assets/landingPage/OurClientele/McA.png" className='clientele' ></img>
         <img alt="" src="/assets/landingPage/OurClientele/IBM.png" className='clientele' ></img>          
         <img alt="" src="/assets/landingPage/OurClientele/TATA.png" className='clientele' ></img>
         <img alt="" src="/assets/landingPage/OurClientele/IQVIA.png" className='clientele' ></img> 
         
        </Stack>
      </Container> 
      <Container
  sx={{
    height: "auto",
    padding: "0 !important",
    backgroundColor: "#000000",
    maxWidth: "100% !important",
    position: "relative",
    background:
      "linear-gradient(90deg, #8A035D 0%, #8A035D 0%, #DA7EB4 50%, #DA7EB4 100%)"
  }}
>
<Stack
  direction={{ xs: "column", sm: "row" }} // Column on mobile, row on larger screens
  spacing={0}
  sx={{
    display: "flex",
    alignItems: { xs: "center", sm: "flex-start" }, // Center text on mobile
    textAlign: { xs: "center", sm: "left" }, // Center text on mobile
  }}
>
  {/* Left Content Box */}
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      height: "auto",
      alignItems: { xs: "center", sm: "flex-start" },
      flex: 1,
      padding: { xs: "5% 8%", sm: "3% 5% 5% 5%" }, // More padding on mobile
    }}
  >
    {/* Heading */}
    <div
      className="section-heading"
      style={{
        fontFamily: "Orbitron",
        fontSize: "50px",
        fontWeight: "bold",
        color: "#FFFFFF",
        paddingTop: "2%",
        textAlign: "left", // default for larger screens
      }}
    >
      Have a project in mind?
    </div>

    {/* Description */}
    <div className="section-description"
      style={{
        fontFamily: "Poppins",
        fontSize: "25px",
        color: "#FFFFFF",
        lineHeight: "47.6px",
        letterSpacing: "1px",
        marginTop: "8%",
      }}
    >
      We'd love to talk with you and Find Out
    </div>
    <div
      className="section-description"
      style={{
        fontFamily: "Poppins",
        fontSize: "25px",
        color: "#FFFFFF",
        lineHeight: "47.6px",
        letterSpacing: "1px",
      }}
    >
      How We Can Help Solve Your Business
    </div>
    <div
    className="section-description"
      style={{
        fontFamily: "Poppins",
        fontSize: "25px",
        color: "#FFFFFF",
        lineHeight: "47.6px",
        letterSpacing: "1px",
      }}
    >
      Process Challenges.
    </div>

    {/* Contact Button */}
    <Box sx={{ display: "flex", paddingTop: "10%" }}>
      <Link to="/clientForm" style={{ textDecoration: "none" }}>
        <div
          className="contactUsBtn"
          style={{
            display: "flex",
            width: "210.84px",
            height: "52.23px",
            backgroundColor: "#000000",
            borderRadius: "45.25px",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 2%",
          }}
        >
          <div
            className="contactUsbtn__text"
            style={{
              fontWeight: "700",
            }}
          >
            Contact Us
          </div>
          <div
            className="contactUsBtn__Arrow"
            style={{
              width: "32.84px",
              height: "32.23px",
              backgroundColor: "#FFFFFF",
              borderRadius: "45.25px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "7%",
            }}
          >
            <ArrowForwardIcon />
          </div>
        </div>
      </Link>
    </Box>
  </Box>

  {/* Right Image Box */}
  <Box
    sx={{
      display: { xs: "none", sm: "flex" }, // Hide image on mobile, show on larger screens
      flexDirection: "column",
      height: { xs: "auto", sm: "450px" }, // Smaller height for mobile
      flex: 1,
      padding: { xs: "5% 0", sm: "2% 0 4% 0" },
      backgroundImage: `url('/assets/landingPage/projectsImage.webp')`,
      backgroundSize: "cover",
      backgroundPosition: { xs: "center", sm: "left" }, // Adjust image position for mobile
      backgroundRepeat: "no-repeat",
      width: "100%", // Ensures proper scaling
    }}
  />
  {/* For mobile, use the image as the background */}
  
</Stack>

</Container>
 
        </> 
        )
};


export default ClientPage;